// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Direction C — Plus Jakarta Sans (UI) + IBM Plex Mono (numbers / IDs).
   Fonts are loaded in index.css. Every selector from the original App.css
   is kept; only values changed. */

:root {
  --ink: #0f1b2a;
  --ink-2: #3d4c60;
  --muted: #66748a;
  --line: #e4e9ef;
  --field-edge: #d5dee7;
  --primary: #0b5c8a;
  --primary-dark: #084767;
  --primary-tint: #eaf2fb;
  --primary-edge: #c9def3;
  --error: #c42b24;
  --page: #f4f7fa;
  --font: "Plus Jakarta Sans", system-ui, -apple-system, sans-serif;
  --mono: "IBM Plex Mono", ui-monospace, monospace;
}

body {
  font-family: var(--font);
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.border-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--page);
}

form {
  width: 30%;
  min-width: 360px;
  box-sizing: border-box;
  padding: 28px 24px 24px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid var(--line);
  box-shadow: 0 24px 48px -28px rgba(15, 27, 42, 0.28);
  border-radius: 16px;
}

label {
  display: block;
  margin-bottom: 6px;
  color: var(--ink-2);
  font-family: var(--font);
  font-size: 12px;
  font-weight: 600;
}

input,
textarea,
select {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid var(--field-edge);
  border-radius: 10px;
  border-width: 1px;
  font-family: var(--font);
  font-size: 14px;
  color: var(--ink);
}

.MuiOutlinedInput-input {
  padding: 7px 7px !important;
}

.custom-select {
  width: 100%;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid var(--field-edge);
  border-radius: 10px;
  border-width: 1px;
}
.react-international-phone-input {
  padding: 10px 12px !important;
  margin-bottom: 16px !important;
  border: 1px solid var(--field-edge) !important;
  border-radius: 10px !important;
}

input[type="checkbox"] {
  width: auto;
  accent-color: var(--primary);
}

.btn-contained {
  background: var(--primary) !important;
  color: #ffffff !important;
  box-shadow: none;
  border-radius: 10px !important;
  margin-top: 20px !important;
  font-family: var(--font) !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 8px 20px !important;
}

.btn-contained:hover {
  background: var(--primary-dark) !important;
}

.btn-outlined {
  color: var(--ink) !important;
  background: #ffffff !important;
  border: 1px solid var(--field-edge) !important;
  border-radius: 10px !important;
  margin-top: 20px !important;
  font-family: var(--font) !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 8px 20px !important;
}

.btn-outlined:hover {
  background: #f4f7fa !important;
}

.error {
  text-align: start;
  color: var(--error);
  margin-top: -10px;
  font-size: 12px;
  font-weight: 500;
}

.form {
  width: 50%;
}

input::placeholder,
textarea::placeholder {
  color: #8a97a8;
}

.password-field {
  width: 100%;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.styled-input {
  width: 100%;
  padding: 10px 44px 10px 12px;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid var(--field-edge);
  border-radius: 10px;
  outline: none;
  font-size: 14px;
}

.toggle-icon {
  position: absolute;
  top: 10px;
  right: 12px;
  cursor: pointer;
  color: #8a97a8;
  /* display: flex; */
  /* align-items: center; */
}

.toggle-icon:hover {
  color: var(--ink);
}

.sidebar {
  background: #ffffff;
}

/* Sidebar scrollbar */
.sidebar .MuiDrawer-paper {
  overflow-y: auto;

  scrollbar-width: thin;
  scrollbar-color: #c3cdd9 transparent;
}

.sidebar .MuiDrawer-paper::-webkit-scrollbar {
  width: 8px;
}

.sidebar .MuiDrawer-paper::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar .MuiDrawer-paper::-webkit-scrollbar-thumb {
  background-color: #c3cdd9;
  border-radius: 10px;
}

.sidebar .MuiDrawer-paper::-webkit-scrollbar-thumb:hover {
  background-color: #8a97a8;
}

.add-forms {
  width: 50%;
  box-sizing: border-box;
  margin: 24px auto;
  padding: 20px 24px;
  background: #ffffff;
  border: 1px solid var(--line);
  box-shadow: none;
  border-radius: 14px;
}

.project-checkbox {
  border: 1px solid var(--line);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 42px;
  cursor: pointer;
  background: #ffffff;
}

.checkbox-active {
  background: var(--primary-tint);
  border-color: #9fc3ea;
  color: var(--ink);
  font-weight: 600;
}

.checkbox-locked {
  background: #f1f4f8;
  border-color: var(--line);
  cursor: not-allowed;
}

.form-step {
  border-radius: 50%;
  background: var(--primary-tint);
  border: 1px solid var(--primary-edge);
  width: 26px;
  height: 26px;
  line-height: 24px;
  display: inline-block;
  text-align: center;
  color: #1b4f82;
  font-family: var(--mono);
  font-size: 12px;
  font-weight: 700;
  margin-right: 10px;
}

.lead-history {
  background: #fdf4e1;
  border: 1px solid #f3e0b4;
  border-radius: 14px;
  display: flex;
  align-items: center;
  font-size: 13.5px;
  margin: 10px 0;
}

.lead-id {
  background: #ffffff;
  border: 1px solid #f3e0b4;
  border-radius: 999px;
  color: #8a5a08;
  font-family: var(--mono);
  font-weight: 600;
  width: fit-content;
  margin: auto;
  padding: 6px 16px;
}

.whatsapp-checkbox-wrapper {
  display: inline-flex;
  align-items: center;
  height: 100%;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.whatsapp-checkbox-circle {
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  border-radius: 50%; /* Circle / ellipse */
  border: 1.5px solid #c3cdd9;
  display: inline-block;
  position: relative;
  transition: all 0.25s ease;
  background: #fff;
}

.whatsapp-checkbox-wrapper input:checked + .whatsapp-checkbox-circle {
  background-color: #2fa864; /* WhatsApp green */
  border-color: #2fa864;
  box-shadow: inset 0 0 0 3px #ffffff;
}

input:focus,
textarea:focus,
select:focus {
  border-color: var(--primary);
  outline: none;
  border-width: 1px;
}

.btn-container {
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;
}

.project-selector {
  width: 40% !important ;
}

.styled-input {
  width: 100%;
  height: 44px;
  padding: 0 44px 0 12px;
  border: 1px solid var(--field-edge);
  border-radius: 10px;
  background: #ffffff;
  font-size: 14px;
  line-height: 44px; /* 🔥 center text */
  outline: none;
  margin-bottom: 16px;
}

/* ICON */
/* .toggle-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
} */

/* ================= PHONE FIELD ================= */

.phone-container {
  display: flex;
  align-items: center;
  height: 42px;
  box-sizing: border-box;
  border: 1px solid var(--field-edge); /* single outer border for the whole field */
  border-radius: 10px;
  background: #ffffff;
  margin-bottom: 16px;
  overflow: visible;
}

.phone-container:focus-within {
  border-color: var(--primary);
}

/* LEFT (FLAG + CODE) */
.phone-container > div {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 6px;
  border-right: 1px solid var(--line);
  background: #f7f9fc;
  border-radius: 10px 0 0 10px;
  flex-shrink: 0;
}
/* INPUT */
.phone-container input {
  flex: 1 1;
  height: 100%;
  border: none;
  outline: none;
  padding: 0 12px;
  font-family: var(--mono);
  font-size: 13.5px;
  background: transparent;
  margin-bottom: 0 !important;
}
/* ================= COUNTRY SELECT ================= */

.country-container {
  position: relative;
}

.country-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
}

/* FLAG */
.flag-box {
  width: 20px;
  height: 14px;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 3px;
}

/* CODE */
.country-code {
  font-family: var(--mono);
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

/* ARROW */
.arrow {
  margin-left: 2px;
  color: var(--muted);
  transition: transform 0.2s;
}

.arrow.rotate {
  transform: rotate(180deg);
  color: var(--primary);
}

/* ================= DROPDOWN ================= */

.country-dropdown {
  position: absolute;
  top: 110%;
  left: 0;
  width: 280px;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 12px;
  box-shadow: 0 16px 36px -12px rgba(15, 27, 42, 0.28);
  z-index: 9999;
  overflow: hidden;
}

/* SEARCH */
.search-box {
  padding: 8px;
  border-bottom: 1px solid #edf1f5;
}

.search-box input {
  width: 100%;
  padding: 8px 10px;
  margin: 0;
  border: 1px solid var(--field-edge);
  border-radius: 9px;
  background: #f7f9fc;
}

/* LIST */
.country-list {
  max-height: 240px;
  overflow-y: auto;
  list-style: none;
  padding: 4px;
  margin: 0;
}

/* ITEM */
.country-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.country-item:hover {
  background: #f4f7fa;
}

.country-name {
  flex: 1 1;
  font-size: 13.5px;
  color: var(--ink);
}

.country-code-small {
  font-family: var(--mono);
  font-size: 12px;
  color: var(--muted);
}

/* ================= BUTTON ================= */

.btn-contained {
  background: var(--primary) !important;
  color: #fff !important;
  margin-top: 20px !important;
  font-weight: 600 !important;
}

@media (max-width: 750px) {
  form,
  .form {
    width: 90%;
    min-width: 0;
  }

  .add-forms {
    width: 100%;
    padding: 16px;
  }

  form {
    padding: 22px 18px;
  }

  h5 {
    text-align: center;
  }

  .btn-container {
    justify-content: center;
  }

  .project-selector {
    width: 100% !important;
  }
}

.card-tag {
  border-radius: 999px;
  background: var(--primary-tint);
  border: 1px solid var(--primary-edge);
  color: #1b4f82;
  font-size: 12px;
  font-weight: 600;
  height: fit-content;
  padding: 3px 10px;
  text-transform: capitalize;
}

.card {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 14px;
  border-left: 1px solid var(--line);
  padding: 14px 16px;
  margin: 10px 0;
}

.card:nth-child(even) {
  background-color: #ffffff;
}

.Mui-checked + .MuiSwitch-track {
  background-color: var(--primary) !important;
  opacity: 1 !important;
}

.MuiSwitch-thumb {
  background-color: #ffffff !important;
}

.input-error {
  border: 1px solid var(--error) !important;
}

.error-text {
  color: var(--error);
  font-size: 12px;
  font-weight: 500;
  margin-top: -10px;
  margin-bottom: 10px;
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;kCAEkC;;AAElC;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iEAAiE;EACjE,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8CAA8C;EAC9C,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;;EAEhB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB,EAAE,qBAAqB;EACzC,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;;;EAGE,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB,EAAE,mBAAmB;EACtC,aAAa;EACb,mBAAmB;AACrB;;AAEA,SAAS;AACT;;;;;;GAMG;;AAEH,oDAAoD;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mCAAmC,EAAE,4CAA4C;EACjF,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;AACA,UAAU;AACV;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA,uDAAuD;;AAEvD;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iDAAiD;;AAEjD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,oDAAoD;EACpD,aAAa;EACb,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA,SAAS;AACT;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA,+CAA+C;;AAE/C;EACE,qCAAqC;EACrC,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE;;IAEE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf","sourcesContent":["/* Direction C — Plus Jakarta Sans (UI) + IBM Plex Mono (numbers / IDs).\n   Fonts are loaded in index.css. Every selector from the original App.css\n   is kept; only values changed. */\n\n:root {\n  --ink: #0f1b2a;\n  --ink-2: #3d4c60;\n  --muted: #66748a;\n  --line: #e4e9ef;\n  --field-edge: #d5dee7;\n  --primary: #0b5c8a;\n  --primary-dark: #084767;\n  --primary-tint: #eaf2fb;\n  --primary-edge: #c9def3;\n  --error: #c42b24;\n  --page: #f4f7fa;\n  --font: \"Plus Jakarta Sans\", system-ui, -apple-system, sans-serif;\n  --mono: \"IBM Plex Mono\", ui-monospace, monospace;\n}\n\nbody {\n  font-family: var(--font);\n  color: var(--ink);\n  -webkit-font-smoothing: antialiased;\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.border-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: var(--page);\n}\n\nform {\n  width: 30%;\n  min-width: 360px;\n  box-sizing: border-box;\n  padding: 28px 24px 24px;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1px solid var(--line);\n  box-shadow: 0 24px 48px -28px rgba(15, 27, 42, 0.28);\n  border-radius: 16px;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--ink-2);\n  font-family: var(--font);\n  font-size: 12px;\n  font-weight: 600;\n}\n\ninput,\ntextarea,\nselect {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  margin-bottom: 16px;\n  background: #ffffff;\n  border: 1px solid var(--field-edge);\n  border-radius: 10px;\n  border-width: 1px;\n  font-family: var(--font);\n  font-size: 14px;\n  color: var(--ink);\n}\n\n.MuiOutlinedInput-input {\n  padding: 7px 7px !important;\n}\n\n.custom-select {\n  width: 100%;\n  margin-bottom: 16px;\n  background: #ffffff;\n  border: 1px solid var(--field-edge);\n  border-radius: 10px;\n  border-width: 1px;\n}\n.react-international-phone-input {\n  padding: 10px 12px !important;\n  margin-bottom: 16px !important;\n  border: 1px solid var(--field-edge) !important;\n  border-radius: 10px !important;\n}\n\ninput[type=\"checkbox\"] {\n  width: auto;\n  accent-color: var(--primary);\n}\n\n.btn-contained {\n  background: var(--primary) !important;\n  color: #ffffff !important;\n  box-shadow: none;\n  border-radius: 10px !important;\n  margin-top: 20px !important;\n  font-family: var(--font) !important;\n  font-weight: 600 !important;\n  text-transform: none !important;\n  padding: 8px 20px !important;\n}\n\n.btn-contained:hover {\n  background: var(--primary-dark) !important;\n}\n\n.btn-outlined {\n  color: var(--ink) !important;\n  background: #ffffff !important;\n  border: 1px solid var(--field-edge) !important;\n  border-radius: 10px !important;\n  margin-top: 20px !important;\n  font-family: var(--font) !important;\n  font-weight: 600 !important;\n  text-transform: none !important;\n  padding: 8px 20px !important;\n}\n\n.btn-outlined:hover {\n  background: #f4f7fa !important;\n}\n\n.error {\n  text-align: start;\n  color: var(--error);\n  margin-top: -10px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.form {\n  width: 50%;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  color: #8a97a8;\n}\n\n.password-field {\n  width: 100%;\n}\n\n.input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.styled-input {\n  width: 100%;\n  padding: 10px 44px 10px 12px;\n  margin-bottom: 16px;\n  background: #ffffff;\n  border: 1px solid var(--field-edge);\n  border-radius: 10px;\n  outline: none;\n  font-size: 14px;\n}\n\n.toggle-icon {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  cursor: pointer;\n  color: #8a97a8;\n  /* display: flex; */\n  /* align-items: center; */\n}\n\n.toggle-icon:hover {\n  color: var(--ink);\n}\n\n.sidebar {\n  background: #ffffff;\n}\n\n/* Sidebar scrollbar */\n.sidebar .MuiDrawer-paper {\n  overflow-y: auto;\n\n  scrollbar-width: thin;\n  scrollbar-color: #c3cdd9 transparent;\n}\n\n.sidebar .MuiDrawer-paper::-webkit-scrollbar {\n  width: 8px;\n}\n\n.sidebar .MuiDrawer-paper::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar .MuiDrawer-paper::-webkit-scrollbar-thumb {\n  background-color: #c3cdd9;\n  border-radius: 10px;\n}\n\n.sidebar .MuiDrawer-paper::-webkit-scrollbar-thumb:hover {\n  background-color: #8a97a8;\n}\n\n.add-forms {\n  width: 50%;\n  box-sizing: border-box;\n  margin: 24px auto;\n  padding: 20px 24px;\n  background: #ffffff;\n  border: 1px solid var(--line);\n  box-shadow: none;\n  border-radius: 14px;\n}\n\n.project-checkbox {\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 42px;\n  cursor: pointer;\n  background: #ffffff;\n}\n\n.checkbox-active {\n  background: var(--primary-tint);\n  border-color: #9fc3ea;\n  color: var(--ink);\n  font-weight: 600;\n}\n\n.checkbox-locked {\n  background: #f1f4f8;\n  border-color: var(--line);\n  cursor: not-allowed;\n}\n\n.form-step {\n  border-radius: 50%;\n  background: var(--primary-tint);\n  border: 1px solid var(--primary-edge);\n  width: 26px;\n  height: 26px;\n  line-height: 24px;\n  display: inline-block;\n  text-align: center;\n  color: #1b4f82;\n  font-family: var(--mono);\n  font-size: 12px;\n  font-weight: 700;\n  margin-right: 10px;\n}\n\n.lead-history {\n  background: #fdf4e1;\n  border: 1px solid #f3e0b4;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  font-size: 13.5px;\n  margin: 10px 0;\n}\n\n.lead-id {\n  background: #ffffff;\n  border: 1px solid #f3e0b4;\n  border-radius: 999px;\n  color: #8a5a08;\n  font-family: var(--mono);\n  font-weight: 600;\n  width: fit-content;\n  margin: auto;\n  padding: 6px 16px;\n}\n\n.whatsapp-checkbox-wrapper {\n  display: inline-flex;\n  align-items: center;\n  height: 100%;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.whatsapp-checkbox-circle {\n  width: 18px;\n  height: 18px;\n  box-sizing: border-box;\n  border-radius: 50%; /* Circle / ellipse */\n  border: 1.5px solid #c3cdd9;\n  display: inline-block;\n  position: relative;\n  transition: all 0.25s ease;\n  background: #fff;\n}\n\n.whatsapp-checkbox-wrapper input:checked + .whatsapp-checkbox-circle {\n  background-color: #2fa864; /* WhatsApp green */\n  border-color: #2fa864;\n  box-shadow: inset 0 0 0 3px #ffffff;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  border-color: var(--primary);\n  outline: none;\n  border-width: 1px;\n}\n\n.btn-container {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  gap: 10px;\n}\n\n.project-selector {\n  width: 40% !important ;\n}\n\n.styled-input {\n  width: 100%;\n  height: 44px;\n  padding: 0 44px 0 12px;\n  border: 1px solid var(--field-edge);\n  border-radius: 10px;\n  background: #ffffff;\n  font-size: 14px;\n  line-height: 44px; /* 🔥 center text */\n  outline: none;\n  margin-bottom: 16px;\n}\n\n/* ICON */\n/* .toggle-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n} */\n\n/* ================= PHONE FIELD ================= */\n\n.phone-container {\n  display: flex;\n  align-items: center;\n  height: 42px;\n  box-sizing: border-box;\n  border: 1px solid var(--field-edge); /* single outer border for the whole field */\n  border-radius: 10px;\n  background: #ffffff;\n  margin-bottom: 16px;\n  overflow: visible;\n}\n\n.phone-container:focus-within {\n  border-color: var(--primary);\n}\n\n/* LEFT (FLAG + CODE) */\n.phone-container > div {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding: 0 6px;\n  border-right: 1px solid var(--line);\n  background: #f7f9fc;\n  border-radius: 10px 0 0 10px;\n  flex-shrink: 0;\n}\n/* INPUT */\n.phone-container input {\n  flex: 1;\n  height: 100%;\n  border: none;\n  outline: none;\n  padding: 0 12px;\n  font-family: var(--mono);\n  font-size: 13.5px;\n  background: transparent;\n  margin-bottom: 0 !important;\n}\n/* ================= COUNTRY SELECT ================= */\n\n.country-container {\n  position: relative;\n}\n\n.country-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n/* FLAG */\n.flag-box {\n  width: 20px;\n  height: 14px;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  border-radius: 3px;\n}\n\n/* CODE */\n.country-code {\n  font-family: var(--mono);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink);\n}\n\n/* ARROW */\n.arrow {\n  margin-left: 2px;\n  color: var(--muted);\n  transition: transform 0.2s;\n}\n\n.arrow.rotate {\n  transform: rotate(180deg);\n  color: var(--primary);\n}\n\n/* ================= DROPDOWN ================= */\n\n.country-dropdown {\n  position: absolute;\n  top: 110%;\n  left: 0;\n  width: 280px;\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  box-shadow: 0 16px 36px -12px rgba(15, 27, 42, 0.28);\n  z-index: 9999;\n  overflow: hidden;\n}\n\n/* SEARCH */\n.search-box {\n  padding: 8px;\n  border-bottom: 1px solid #edf1f5;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 8px 10px;\n  margin: 0;\n  border: 1px solid var(--field-edge);\n  border-radius: 9px;\n  background: #f7f9fc;\n}\n\n/* LIST */\n.country-list {\n  max-height: 240px;\n  overflow-y: auto;\n  list-style: none;\n  padding: 4px;\n  margin: 0;\n}\n\n/* ITEM */\n.country-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n}\n\n.country-item:hover {\n  background: #f4f7fa;\n}\n\n.country-name {\n  flex: 1;\n  font-size: 13.5px;\n  color: var(--ink);\n}\n\n.country-code-small {\n  font-family: var(--mono);\n  font-size: 12px;\n  color: var(--muted);\n}\n\n/* ================= BUTTON ================= */\n\n.btn-contained {\n  background: var(--primary) !important;\n  color: #fff !important;\n  margin-top: 20px !important;\n  font-weight: 600 !important;\n}\n\n@media (max-width: 750px) {\n  form,\n  .form {\n    width: 90%;\n    min-width: 0;\n  }\n\n  .add-forms {\n    width: 100%;\n    padding: 16px;\n  }\n\n  form {\n    padding: 22px 18px;\n  }\n\n  h5 {\n    text-align: center;\n  }\n\n  .btn-container {\n    justify-content: center;\n  }\n\n  .project-selector {\n    width: 100% !important;\n  }\n}\n\n.card-tag {\n  border-radius: 999px;\n  background: var(--primary-tint);\n  border: 1px solid var(--primary-edge);\n  color: #1b4f82;\n  font-size: 12px;\n  font-weight: 600;\n  height: fit-content;\n  padding: 3px 10px;\n  text-transform: capitalize;\n}\n\n.card {\n  background: #ffffff;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  border-left: 1px solid var(--line);\n  padding: 14px 16px;\n  margin: 10px 0;\n}\n\n.card:nth-child(even) {\n  background-color: #ffffff;\n}\n\n.Mui-checked + .MuiSwitch-track {\n  background-color: var(--primary) !important;\n  opacity: 1 !important;\n}\n\n.MuiSwitch-thumb {\n  background-color: #ffffff !important;\n}\n\n.input-error {\n  border: 1px solid var(--error) !important;\n}\n\n.error-text {\n  color: var(--error);\n  font-size: 12px;\n  font-weight: 500;\n  margin-top: -10px;\n  margin-bottom: 10px;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
